import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
// @ts-ignore
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
// @ts-ignore
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
// @ts-ignore
import Gitub from "@iconscout/react-unicons/icons/uil-github";
// @ts-ignore
import LinkedIn from "@iconscout/react-unicons/icons/uil-linkedin";
// @ts-ignore
import Telegram from "@iconscout/react-unicons/icons/uil-telegram";

const Footer = () => {
    return (
        <div className="footer">
            <img src={Wave} alt="" style={{width: "100%"}}/>
            <div className="f-content">
                <span>ozodnx@gmail.com</span>
                <div className="f-icons">
                    <a
                        href="https://www.instagram.com/ozodbekxayrullayev/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Insta color="white" size={"3rem"}/>
                    </a>
                    <a
                        href="https://au.linkedin.com/in/ozodbek-xayrullayev-a61b0a162/?trk=profile-badge"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <LinkedIn color="white" size={"3rem"}/>
                    </a>
                    <a
                        href="https://github.com/OzodbekX"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Gitub color="white" size={"3rem"}/>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Footer;
